import { render } from "./ListDataPh.vue?vue&type=template&id=797c4bd4"
import script from "./ListDataPh.vue?vue&type=script&lang=js"
export * from "./ListDataPh.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__